module.exports = __webpack_public_path__ + "assets/img/map.be29ad82.png";